<template>
  <section class="sec-contact">
    <div class="sec-titr">
      <h1 class="sec-titr__title">ارتباط با ما</h1>
    </div>
    <div class="container-contact">
      <div class="contact">
        <form class="contact-text">
          <div class="contact-text-name contact-text-input">
            <input type="text" placeholder="نام" />
          </div>
          <div class="contact-text-email contact-text-input">
            <input type="text" placeholder="ایمیل" />
          </div>
          <div class="contact-text-phone contact-text-input">
            <input type="text" placeholder="شماره موبایل" />
          </div>
          <div class="contact-text-massage contact-text-input">
            <textarea cols="30" rows="10" placeholder="پیام"></textarea>
          </div>
          <div class="contact-text-btn">
            <button type="button" class="base-btn-1">ارسال</button>
          </div>
        </form>
        <div class="contact-icons">
          <div class="contact-icons__item">
            <div class="contact-icons__item-icon">
              <i class="fas fa-phone"></i>
            </div>
            <span class="contact-icons-icon-text">...559342</span>
          </div>

          <div class="contact-icons__item">
            <div class="contact-icons__item-icon">
              <i class="fas fa-gamepad"></i>
            </div>
            <span class="contact-icons-icon-text">nishva...@gmail.com</span>
          </div>

          <div class="contact-icons__item">
            <div class="contact-icons__item-icon">
              <i class="fas fa-map"></i>
            </div>
            <span class="contact-icons-icon-text"
              >تهران شهرک غرب خیابان شاهد...</span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
